import { getCompanyListWebPage } from 'commons/service/bank/company'
import { CompanyListWebPageRequest } from 'commons/types/DTO/bank/companyList/CompanyListWebPageRequest'
import { CompanyListWebPageResponse } from 'commons/types/DTO/bank/companyList/CompanyListWebPageResponse'
import { Keys, ReadHook, useStateManager } from 'state-manager'

export const useGetCompanyList: ReadHook<CompanyListWebPageResponse, CompanyListWebPageRequest> = (opts) =>
  useStateManager().use(Keys.Relationships.List(opts), () => getCompanyListWebPage(opts), { keepPreviousData: true })
